<script setup lang="ts">
import { useElementalForm } from '../ElementalFormContextProvider/context'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
defineOptions({
  name: 'FormSavingIndicator',
})

const { isSaving, isLoading, isSidebarView, submitError } = useElementalForm()
const isTakingLongTime = ref(false)
const longSaveTimeoutId = ref<NodeJS.Timeout | null>(null)

watch(() => isSaving?.value, (isSaving) => {
  if (isSaving) {
    longSaveTimeoutId.value = setTimeout(() => {
      isTakingLongTime.value = true
    }, 1000)
  }
  else {
    if (longSaveTimeoutId.value) {
      clearTimeout(longSaveTimeoutId.value)
      longSaveTimeoutId.value = null
    }
    isTakingLongTime.value = false
  }
})
</script>

<template>
  <div class="flex flex-col items-center justify-center gap-1 text-sm text-dark-gray min-w-3 min-h-10" v-bind="$attrs">
    <div v-if="isSaving || isLoading " class="flex items-center space-x-1">
      <div class="w-2 h-2 bg-primary rounded-full animate-pulse" />
      <span v-if="!isSidebarView && isSaving">Saving</span>
    </div>
    <div v-else-if="submitError" class="flex items-center space-x-1 text-amber-500">
      <span class="i-mdi:offline text-amber-500" />
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger>
            <span v-if="!isSidebarView">Error</span>
          </TooltipTrigger>
          <TooltipContent class="p-2 max-w-md bg-yellow-100/80 rounded" align="center" side="bottom">
            <p class="text-sm font-bold font-inter">
              An error occurred while saving. Click to try again.
            </p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
    <div v-else class="flex items-center space-x-1">
      <span class="i-mdi:check text-black" />
      <span v-if="!isSidebarView">Saved</span>
    </div>
  </div>
</template>
